/*
  codes.js: discount-code bootstrap. Owner: CART. ES module, every page. Contract: CONTRACT.md 8, E3.8, E6.5.
  Tiny on purpose (budget 2.5 KB minified): it only decides whether this page needs the code logic and then
  imports assets/codes-apply.js (URL from [data-cart-config]). It never touches location or history.
  Loads the logic when the URL has any query (?code= / ?discount=, or a legacy ad link with utm_* / fbclid),
  a code is remembered (session/local storage), Shopify set a discount_code cookie, or the cart has items;
  and on every cart:updated that codes did not cause (re-assert the code after adds, keep the SAUNAPAIR
  pair code exactly while a case and an underwear line are both in the cart).
*/
import { bus } from '@theme/global';

const d = document;
let mod;
const run = (fn, x) =>
  (mod ||= import(JSON.parse(d.querySelector('[data-cart-config]').textContent).codes))
    .then((m) => m[fn](x))
    .catch(() => {});

bus.on('cart:updated', (x) => x.source !== 'codes' && run('updated', x));

let need = location.search.length > 1 || /discount_code=/.test(d.cookie);
try {
  need ||= !!(sessionStorage.getItem('ssc:code') || localStorage.getItem('ssc:code'));
} catch (e) {}
const n = d.querySelector('[data-cart-count]');
if (need || (n && +n.textContent > 0)) run('boot');
